import type { AutomationsTranslation } from './types';

export const automationsUr: AutomationsTranslation = {
  nav: 'آٹومیشن',
  title: 'آٹومیشن',
  description:
    'خود بخود کام کرنے والے اصول: آپ کی ویب سائٹ پر پیغامات، اور چیٹ میں جوابات، ٹیگ اور ٹکٹ۔ اصول تبھی چلتا ہے جب وہ شائع اور آن ہو۔',
  loading: 'آٹومیشن لوڈ ہو رہے ہیں',
  brand: 'برانڈ',
  open: 'آٹومیشن',
  openLabel: '{{name}} کے آٹومیشن',
  guide: 'آٹومیشن کیسے کام کرتے ہیں',
  noPermission: 'آپ کا کردار آٹومیشن نہیں بدل سکتا۔ ورک اسپیس کے مالک یا منتظم سے کہیں۔',
  forbidden: {
    title: 'آپ آٹومیشن نہیں دیکھ سکتے',
    description: 'ورک اسپیس کے مالک یا منتظم سے ایسا کردار مانگیں جو آٹومیشن دیکھ سکے۔',
  },
  noBrands: {
    title: 'ابھی کوئی برانڈ نہیں',
    description: 'پہلے ایک برانڈ اور اس کی ویب سائٹ شامل کریں۔ پھر اس کے آٹومیشن یہاں ترتیب دیں۔',
    action: 'برانڈز اور انسٹال پر جائیں',
  },
  new: 'نیا آٹومیشن',
  sections: {
    visitor: {
      title: 'آپ کی ویب سائٹ پر',
      description:
        'چیٹ بٹن کے پاس پیغامات جو وزیٹرز کو پوچھنے کی دعوت دیتے ہیں۔ یہ وزیٹرز کے براؤزر میں چلتے ہیں۔',
    },
    conversation: {
      title: 'چیٹ میں',
      description: 'چیٹ کے دوران جوابات، نوٹس، ٹیگ، ترجیحات، ٹیمیں اور ٹکٹ۔',
    },
    empty: 'ابھی کچھ نہیں۔',
  },
  status: {
    off: 'بند',
    draft: 'صرف مسودہ',
    changes: 'ورژن {{version}} شائع · غیر شائع شدہ تبدیلیاں',
    published: 'ورژن {{version}} شائع',
  },
  list: {
    edit: 'ترمیم',
    editLabel: '{{name}} میں ترمیم کریں',
    duplicate: 'نقل بنائیں',
    duplicateLabel: '{{name}} کی نقل بنائیں',
    delete: 'حذف کریں',
    deleteLabel: '{{name}} حذف کریں',
    switchLabel: '{{name}} چلائیں',
    inBrowser: 'وزیٹرز کے براؤزر میں چلتا ہے',
    neverRan: 'ابھی تک نہیں چلا',
    ranOnce: 'اس ہفتے ایک بار چلا',
    ranTimes: 'اس ہفتے {{n}} بار چلا',
    ranLast: '{{ran}} · آخری بار {{when}}',
    copyName: '{{name}} (نقل)',
    duplicated: '{{name}} مسودے کے طور پر بنا۔',
    turnedOn: '{{name}} آن ہے۔',
    turnedOff: '{{name}} بند ہے۔',
    deleted: '{{name}} حذف ہو گیا۔',
    deleteTitle: '{{name}} حذف کریں؟',
    deleteBody:
      'اس کے ورژن اور اس نے جو کیا اس کا ریکارڈ بھی حذف ہو جائے گا۔ اسے واپس نہیں کیا جا سکتا۔ فی الحال روکنا ہو تو اسے بند کر دیں۔',
    deleteConfirm: 'آٹومیشن حذف کریں',
  },
  gallery: {
    title: 'ٹیمپلیٹ سے شروع کریں',
    description:
      'شروع کرنے کے لیے ایک اصول چنیں۔ یہ مسودے کے طور پر محفوظ ہوتا ہے، تاکہ چلنے سے پہلے آپ اسے جانچ سکیں۔',
    ready: 'تیار اصول',
    scratch: 'شروع سے بنائیں',
    scratchDescription: 'ایک خالی اصول جو آپ خود لکھیں۔',
    website: 'آپ کی ویب سائٹ پر',
    chat: 'چیٹ میں',
    use: 'استعمال کریں',
    useLabel: 'ٹیمپلیٹ {{name}} استعمال کریں',
    created: '{{name}} مسودے کے طور پر بنا۔',
    chooseTag: 'ٹیگ آپ چنتے ہیں۔',
  },
  templates: {
    welcome: {
      name: 'خوش آمدیدی جواب',
      description: 'جب چیٹ شروع ہو اور کسی شخص کا انتظار ہو، بتائیں کہ جلد کوئی جواب دے گا۔',
    },
    rescue: {
      name: 'چیٹ بچاؤ',
      description: '90 سیکنڈ تک جواب نہ ملنے پر معذرت کریں، ای میل پتہ پوچھیں اور ترجیح بڑھائیں۔',
    },
    returning: {
      name: 'واپس آنے والے وزیٹر کا پیغام',
      description: 'تیسری یا اس کے بعد کی وزٹ پر، 5 سیکنڈ بعد مدد پیش کریں۔',
    },
    pricing: {
      name: 'قیمتوں کے صفحے پر مدد',
      description: 'قیمتوں کے صفحے پر 30 سیکنڈ بعد، سوالوں کے جواب دینے کی پیشکش کریں۔',
    },
    outOfHours: {
      name: 'کام کے اوقات کے بعد جواب',
      description: 'کام کے اوقات کے باہر، بتائیں کہ آپ کب جواب دیں گے اور چیٹ کو ٹکٹ بنائیں۔',
    },
    tagByPage: {
      name: 'صفحے کے لحاظ سے ٹیگ',
      description: 'چیک آؤٹ صفحے پر شروع ہونے والی چیٹ پر ٹیگ لگائیں۔',
    },
    scratchWebsite: {
      name: 'نیا ویب سائٹ پیغام',
      description: 'آپ کی ویب سائٹ پر ایک پیغام۔',
    },
    scratchChat: {
      name: 'نیا چیٹ آٹومیشن',
      description: 'چیٹ میں کام کرنے والا اصول۔',
    },
  },
  limits: {
    title: 'پیغامات کی حد',
    description:
      'آپ کے پاس ویب سائٹ کے جتنے بھی آٹومیشن ہوں، ایک وزیٹر کو زیادہ سے زیادہ اتنے پیغامات دکھتے ہیں۔',
    maxPerDay: 'ایک وزیٹر کو ایک دن میں دکھنے والے پیغامات',
    maxPerDayHint: '1 سے 3 تک۔',
    dismissHours: 'وزیٹر کے ایک پیغام بند کرنے کے بعد، انتظار کریں (گھنٹے)',
    dismissHoursHint: '1 سے 168 (ایک ہفتہ) تک۔',
    invalid: '{{min}} سے {{max}} تک کوئی پورا عدد لکھیں۔',
    save: 'حد محفوظ کریں',
    saved: '{{name}} کے لیے پیغامات کی حد محفوظ ہو گئی۔',
  },
  editor: {
    loading: 'آٹومیشن لوڈ ہو رہا ہے',
    back: 'تمام آٹومیشن',
    kinds: { visitor: 'ویب سائٹ آٹومیشن', conversation: 'چیٹ آٹومیشن' },
    name: 'نام',
    nameHint: 'آپ کی ٹیم کے لیے۔ گاہک اسے کبھی نہیں دیکھتے۔',
    whenStep: {
      title: 'جب',
      description: 'اصول کس چیز سے شروع ہوتا ہے۔',
      event: 'واقعہ',
      seconds: {
        page_view: 'صفحے پر سیکنڈ',
        customer_waiting: 'جواب کے بغیر سیکنڈ',
      },
      secondsHint: '{{min}} سے {{max}} تک۔',
      kindNote:
        'ویب سائٹ آٹومیشن ویب سائٹ پر ہی رہتا ہے، اور چیٹ آٹومیشن چیٹ میں۔ دوسری قسم بنانے کے لیے نیا آٹومیشن شروع کریں۔',
    },
    ifStep: {
      title: 'اگر',
      description: 'کیا درست ہونا چاہیے۔ ہر بار چلانے کے لیے اسے خالی چھوڑ دیں۔',
      match: 'تب چلائیں جب',
      all: 'سب درست ہوں',
      any: 'کوئی بھی درست ہو',
      condition: 'شرط {{number}}',
      field: 'معلومات',
      op: 'جانچ',
      value: 'قدر',
      yes: 'ہاں',
      no: 'نہیں',
      empty: 'کوئی شرط نہیں: واقعہ ہونے پر اصول ہر بار چلتا ہے۔',
      count: '{{max}} میں سے {{n}}',
      add: 'شرط شامل کریں',
      added: 'شرط {{number}} شامل ہو گئی۔',
      remove: 'شرط {{number}} ہٹائیں',
      removeShort: 'ہٹائیں',
      removed: 'شرط {{number}} ہٹا دی گئی۔',
      full: 'ایک اصول میں زیادہ سے زیادہ {{max}} شرطیں ہوتی ہیں۔',
      addValue: 'شامل کریں',
      addValueLabel: 'شرط {{number}} میں شامل کریں',
      removeValue: '{{value}} ہٹائیں',
      countryHint: 'دو حروف کے ملکی کوڈ، جیسے PK یا AE۔ ہر ایک کے بعد Enter دبائیں۔',
      languageHint: 'زبان کے کوڈ، جیسے ar یا en۔ ہر ایک کے بعد Enter دبائیں۔',
      tagHint: 'برانڈ کے ٹیگ لوڈ نہیں ہو سکے۔ ٹیگ لکھیں اور Enter دبائیں۔',
      noTags: 'اس برانڈ کے ابھی کوئی ٹیگ نہیں۔ انہیں محفوظ جوابات اور ٹیگز میں شامل کریں۔',
      noTeams: 'اس برانڈ کی ابھی کوئی سپورٹ ٹیم نہیں۔',
    },
    thenStep: {
      title: 'تو',
      description: 'اصول کیا کرتا ہے، اسی ترتیب سے۔',
      action: 'کارروائی {{number}}',
      type: 'یہ کریں',
      count: '{{max}} میں سے {{n}}',
      add: 'کارروائی شامل کریں',
      added: 'کارروائی {{number}} شامل ہو گئی۔',
      remove: 'کارروائی {{number}} ہٹائیں',
      removeShort: 'ہٹائیں',
      removed: 'کارروائی {{number}} ہٹا دی گئی۔',
      full: 'ایک اصول میں زیادہ سے زیادہ {{max}} کارروائیاں ہوتی ہیں۔',
      prompt: 'ویب سائٹ پیغام',
      message: 'پیغام',
      messageHint:
        'انگریزی ضروری ہے۔ خالی چھوڑی گئی زبان میں انگریزی دکھتی ہے۔ زیادہ سے زیادہ {{max}} حروف۔',
      note: 'ٹیم کے لیے نوٹ',
      tag: 'ٹیگ',
      tagPlaceholder: 'ٹیگ چنیں',
      tagUnknown: '“{{tag}}” اس برانڈ کے ٹیگز میں نہیں ہے۔ شائع کرنے سے پہلے کوئی ٹیگ چنیں۔',
      tagFree: 'ٹیگ کا نام',
      tagFreeHint: 'برانڈ کے ٹیگ لوڈ نہیں ہو سکے۔ ٹیگ بالکل درست لکھیں۔',
      team: 'ٹیم',
      teamPlaceholder: 'ٹیم چنیں',
      priority: 'ترجیح',
    },
    fields: {
      page_url: 'صفحے کا پتہ',
      referrer: 'کہاں سے آئے (ریفرر)',
      visit_count: 'اب تک کی وزٹس',
      country: 'ملک',
      device: 'ڈیوائس',
      language: 'زبان',
      signed_in: 'گاہک سائن ان ہے',
      hours_open: 'کام کے اوقات میں',
      anyone_online: 'ٹیم میں کوئی آن لائن ہے',
      owner: 'چیٹ کس کے پاس ہے',
      tag: 'ٹیگ',
      team: 'ٹیم',
    },
    ops: {
      contains: 'میں شامل ہے',
      starts_with: 'سے شروع ہوتا ہے',
      is: 'ہے',
      not_contains: 'میں شامل نہیں',
      at_least: 'کم از کم',
      at_most: 'زیادہ سے زیادہ',
      is_not: 'نہیں ہے',
    },
    events: {
      page_view: 'وزیٹر کسی صفحے پر ہے',
      chat_started: 'چیٹ شروع ہوتی ہے',
      customer_waiting: 'گاہک جواب کا انتظار کر رہا ہے',
      chat_closed: 'چیٹ بند ہوتی ہے',
      offline_message: 'جب کوئی جواب نہ دے سکے تو پیغام چھوڑا جاتا ہے',
    },
    actions: {
      show_prompt: 'ویب سائٹ پیغام دکھائیں',
      send_message: 'پیغام بھیجیں',
      add_note: 'نجی نوٹ شامل کریں',
      add_tag: 'ٹیگ شامل کریں',
      set_priority: 'ترجیح طے کریں',
      assign_team: 'ٹیم کو بھیجیں',
      make_ticket: 'ٹکٹ بنائیں',
    },
    warnings: {
      title: 'یہ اصول محفوظ ہو سکتا ہے، لیکن اسی طرح شائع نہیں ہو سکتا:',
      field_not_allowed: 'اس قسم کے آٹومیشن میں یہ معلومات دستیاب نہیں۔ کوئی اور چنیں۔',
      action_not_allowed: 'اس قسم کے آٹومیشن میں یہ کارروائی دستیاب نہیں۔',
      action_repeated: 'یہ کارروائی اصول میں پہلے سے ہے۔ اصول اسے صرف ایک بار کرتا ہے۔',
      prompt_required: 'ویب سائٹ آٹومیشن ایک پیغام دکھاتا ہے۔ “ویب سائٹ پیغام دکھائیں” شامل کریں۔',
      message_needs_people:
        'اس چیٹ میں AI جواب دے رہا ہے۔ اس اصول کا پیغام اسے بیچ میں روک دے گا — ‘چیٹ کس کے پاس ہے AI نہیں ہے’ شامل کریں۔',
      message_after_close: 'چیٹ بند ہونے کے بعد پیغام نہیں بھیجا جا سکتا۔',
    },
    problems: {
      name: 'آٹومیشن کو نام دیں۔',
      seconds: '{{min}} سے {{max}} تک سیکنڈ کا پورا عدد لکھیں۔',
      conditionValue: 'شرط {{number}}: کوئی قدر چنیں یا لکھیں۔',
      conditionNumber: 'شرط {{number}}: {{min}} سے {{max}} تک کوئی پورا عدد لکھیں۔',
      conditionLong: 'شرط {{number}}: زیادہ سے زیادہ {{max}} حروف استعمال کریں۔',
      messageEnglish: 'کارروائی {{number}}: الفاظ انگریزی میں لکھیں۔',
      messageLong: 'کارروائی {{number}}: ہر زبان میں زیادہ سے زیادہ {{max}} حروف استعمال کریں۔',
      note: 'کارروائی {{number}}: نوٹ لکھیں۔',
      tag: 'کارروائی {{number}}: ٹیگ چنیں۔',
      team: 'کارروائی {{number}}: ٹیم چنیں۔',
      noActions: 'کم از کم ایک کارروائی شامل کریں۔',
    },
    save: 'مسودہ محفوظ کریں',
    publish: 'شائع کریں',
    saved: '{{name}} کا مسودہ محفوظ ہو گیا۔',
    published: '{{name}} ورژن {{version}} کے طور پر شائع ہو گیا۔',
    unsaved: 'آپ کی کچھ تبدیلیاں محفوظ نہیں ہوئیں۔',
    reset: 'تبدیلیاں واپس لیں',
    enabled: 'آن',
    enabledHint: 'بند کرنے پر اصول رہتا ہے لیکن کبھی نہیں چلتا۔',
    turnedOn: '{{name}} آن ہے۔',
    turnedOff: '{{name}} بند ہے۔',
    statusLine: {
      published: 'ورژن {{version}}، {{who}} نے شائع کیا، {{when}}۔',
      publishedBySystem: 'ورژن {{version}}، {{when}} شائع ہوا جب آپ کے پیغامات یہاں لائے گئے۔',
      draft: 'ابھی شائع نہیں ہوا، اس لیے نہیں چلتا۔',
      changes: 'مسودے میں ایسی تبدیلیاں ہیں جو ابھی شائع نہیں ہوئیں۔',
      off: 'بند ہے، اس لیے نہیں چلتا۔',
    },
    conflict:
      'آپ کے کھولنے کے بعد کسی اور نے یہ آٹومیشن بدلا۔ ان کا ورژن دیکھنے کے لیے دوبارہ لوڈ کریں؛ یہاں کی آپ کی تبدیلیاں ضائع ہو جائیں گی۔',
    reload: 'دوبارہ لوڈ کریں',
    reloaded: 'تازہ ترین ورژن لوڈ ہو گیا۔',
    versions: {
      title: 'ورژن',
      description:
        'ہر اشاعت محفوظ رہتی ہے۔ بحال کرنے سے ورژن مسودے میں نقل ہوتا ہے؛ اسے دوبارہ چلانے کے لیے شائع کریں۔',
      empty: 'ابھی شائع نہیں ہوا۔',
      version: 'ورژن {{version}}',
      by: '{{who}} نے شائع کیا، {{when}}',
      bySystem: 'Hamnivo نے {{when}} شائع کیا',
      current: 'ابھی چل رہا ہے',
      restore: 'بحال کریں',
      restoreLabel: 'ورژن {{version}} بحال کریں',
      restoreTitle: 'ورژن {{version}} بحال کریں؟',
      restoreBody:
        'مسودے کی جگہ ورژن {{version}} آ جائے گا۔ جو چل رہا ہے وہ شائع کرنے پر ہی بدلے گا۔',
      restoreConfirm: 'مسودے میں بحال کریں',
      restored: 'ورژن {{version}} مسودے میں نقل ہو گیا۔',
      saveFirst: 'پہلے اپنی تبدیلیاں محفوظ کریں یا واپس لیں۔',
    },
    runs: {
      title: 'حالیہ اجرا',
      description: 'اس اصول نے چیٹ میں کیا کیا، تازہ ترین پہلے۔',
      empty: 'یہ ابھی تک نہیں چلا۔',
      when: 'کب',
      chat: 'چیٹ',
      actions: 'کارروائیاں',
      result: 'نتیجہ',
      open: 'چیٹ کھولیں',
      noChat: 'کوئی چیٹ نہیں',
      version: 'ورژن {{version}}',
      outcomes: { done: 'ہو گیا', skipped: 'چھوڑ دیا گیا', failed: 'ناکام' },
      reasons: {
        ai_has_chat: 'پیغام نہیں بھیجا گیا: چیٹ AI کے پاس تھی۔',
        message_limit: 'پیغام نہیں بھیجا گیا: خودکار پیغامات کی روزانہ حد پوری ہو گئی۔',
        no_bot: 'پیغام نہیں بھیجا گیا: چیٹ میں بھیجنے کے لیے کوئی بوٹ نہیں۔',
        window_closed:
          'پیغام نہیں بھیجا گیا: گاہک کے آخری پیغام کے 24 گھنٹے بعد واٹس ایپ صرف ٹیمپلیٹ پیغامات کی اجازت دیتا ہے۔',
      },
      noActions: 'کچھ نہیں',
    },
    try: {
      title: 'آزمائیں',
      description:
        'کسی وزیٹر یا چیٹ کی تفصیل دیں اور دیکھیں کہ یہ اصول کیا کرے گا۔ یہ وہی جانچ ہے جو اصل اصول کرتا ہے۔',
      sample: 'نمونہ',
      unknown: 'معلوم نہیں',
      yes: 'ہاں',
      no: 'نہیں',
      tagsHint: 'ٹیگز کو کوما سے الگ کریں۔',
      countryHint: 'دو حروف کا کوڈ، جیسے PK۔',
      would: 'یہ اصول چلے گا۔',
      wouldNot: 'یہ اصول نہیں چلے گا۔',
      verdicts: {
        true: 'درست',
        false: 'درست نہیں',
        null: 'معلوم نہیں، اس لیے درست نہیں',
      },
      noConditions: 'کوئی شرط نہیں: واقعہ ہونے پر یہ ہر بار چلتا ہے۔',
      preview: 'گاہک کو کیا دکھتا ہے',
      previewIn: '{{language}} میں، وزیٹر کی زبان۔',
      noWords: 'یہ اصول گاہک سے کچھ نہیں کہتا۔',
    },
  },
  devices: { desktop: 'کمپیوٹر', mobile: 'فون', tablet: 'ٹیبلیٹ' },
  owners: {
    ai: 'AI',
    waiting: 'ابھی کوئی نہیں (کسی شخص کا انتظار)',
    person: 'کوئی شخص',
  },
  priorities: { urgent: 'فوری', high: 'زیادہ', medium: 'درمیانی', low: 'کم' },
  summary: {
    sentence: '{{event}}، اگر {{conditions}} ← {{actions}}',
    always: '{{event}} ← {{actions}}',
    aTeam: 'کسی ٹیم',
    owners: { ai: 'AI', waiting: 'ابھی کوئی نہیں', person: 'کوئی شخص' },
    devices: { desktop: 'کمپیوٹر', mobile: 'فون', tablet: 'ٹیبلیٹ' },
    priorities: { urgent: 'فوری', high: 'زیادہ', medium: 'درمیانی', low: 'کم' },
    events: {
      page_open: 'جب کوئی وزیٹر صفحہ کھولے',
      page_view: 'جب کوئی وزیٹر {{duration}} سے کسی صفحے پر ہو',
      chat_started: 'جب چیٹ شروع ہو',
      customer_waiting: 'جب گاہک {{duration}} سے جواب کا انتظار کر رہا ہو',
      chat_closed: 'جب چیٹ بند ہو',
      offline_message: 'جب کوئی جواب نہ دے سکے اور پیغام چھوڑا جائے',
    },
    fields: {
      page_url: 'صفحے کا پتہ',
      referrer: 'ریفرر',
      visit_count: 'وزٹس کی تعداد',
      country: 'ملک',
      device: 'ڈیوائس',
      language: 'زبان',
      signed_in: 'سائن ان',
      hours_open: 'کام کے اوقات',
      anyone_online: 'کوئی آن لائن',
      owner: 'چیٹ جس کے پاس ہے وہ',
      tag: 'ٹیگ',
      team: 'ٹیم',
    },
    ops: {
      contains: '{{field}} میں {{value}} شامل ہے',
      starts_with: '{{field}} {{value}} سے شروع ہوتا ہے',
      is: '{{field}} {{value}} ہے',
      not_contains: '{{field}} میں {{value}} شامل نہیں',
      at_least: '{{field}} کم از کم {{value}} ہے',
      at_most: '{{field}} زیادہ سے زیادہ {{value}} ہے',
      is_not: '{{field}} {{value}} نہیں ہے',
    },
    flags: {
      hours_open: { yes: 'کام کے اوقات چل رہے ہیں', no: 'کام کے اوقات کے باہر کا وقت ہے' },
      anyone_online: { yes: 'ٹیم میں کوئی آن لائن ہے', no: 'ٹیم میں کوئی آن لائن نہیں' },
      signed_in: { yes: 'گاہک سائن ان ہے', no: 'گاہک سائن ان نہیں ہے' },
    },
    actions: {
      show_prompt: 'پیغام دکھائیں',
      send_message: 'پیغام بھیجیں',
      add_note: 'نجی نوٹ شامل کریں',
      add_tag: 'ٹیگ {{tag}} شامل کریں',
      set_priority: 'ترجیح {{priority}} کریں',
      assign_team: '{{team}} کو بھیجیں',
      make_ticket: 'ٹکٹ بنائیں',
    },
  },
};
